import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ProjeectDetail from "./components/ProjectDetail/ProjectDetail";
import AboutMe from "./components/about/AboutMe";
import Projects from "./components/Projects/Projects";

function App() {
  return (
    // <div>
    //   <Main />
    // </div>
    <Router>
      <Switch>
        <Route exact path="/">
          <Main />
        </Route>

        <Route path="/home">
          <Main />
        </Route>

        <Route path="/project/:projectId">
          <ProjeectDetail />
        </Route>

        <Route path="/about">
          <AboutMe />
        </Route>

        <Route path="/projects">
          <Projects />
        </Route>

        <Route path="/blogs">

        </Route>

      </Switch>
    </Router>
  );
}

export default App;
